import request from "@/utils/request";
// 分页查询文件组
export function commitGen(data) {
  return request({
    url: "file/group/page",
    method: "post",
    data: data
  });
}

// 查看文件组详细信息
export function groudetail(id) {
  return request({
    url: "file/group/detail",
    method: "post",
    data: {
      id: id
    }
  });
}
// 分页查询pap患者
export function patientquery(data) {
  return request({
    url: "file/group/patient/query",
    method: "post",
    data: data
  });
}
// 查询pap患者基本和系统信息
export function queryDetail(data) {
  return request({
    url: "file/group/patient/queryDetail",
    method: "post",
    data: data
  });
}
// 指定患者(身份证)
export function updateByManual(data) {
  return request({
    url: "file/group/patient/updateByManual",
    method: "post",
    data: data
  });
}
// 录入患者
export function updateByPap(data) {
  return request({
    url: "file/group/patient/updateByPap",
    method: "post",
    data: data
  });
}
// 查看文件历史
export function filedetail(id) {
  return request({
    url: "log/file/detail",
    method: "post",
    data: {
      fileId: id
    }
  });
}

// 删除文件
export function filedel(info) {
  return request({
    url: "file/del",
    method: "post",
    data: info
  });
}
// 更新文件条目
export function fileupdate(data) {
  return request({
    url: "file/update",
    method: "post",
    data: data
  });
}

// 查询阶段和审核条目列表
export function checkItemquery(id) {
  return request({
    url: "file/checkItem/query",
    method: "post",
    data: {
      fileGroupId: id
    }
  });
}

// 重新匹配关联
export function reLink(id) {
  return request({
    url: "file/group/reLink",
    method: "post",
    data: {
      id: id
    }
  });
}

// 导出材料
export function filegroupexport(data) {
  return request({
    url: "file/group/export",
    method: "post",
    data: {
      fileGroupIds: data
    }
  });
}
// 查询材料组导出记录
export function taskpage(data) {
  return request({
    url: "file/group/task/page",
    method: "post",
    data
  });
}

// 删除材料组
export function filegroupdelete(id) {
  return request({
    url: "file/group/delete",
    method: "post",
    data: {
      id: id
    }
  });
}
